var ModalNotLMC = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Отсутствует максимальный вес LMC"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerNotLMC.close();
                          m.route(`/task/${m.route.param('taskId')}/loadsheet`)
                        }
                      }, "Ок")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerNotLMC = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerNotLMC.container = document.querySelector('#ModalNotLMC');
    if (!ModalContainerNotLMC.container) {
      ModalContainerNotLMC.container = document.createElement('div');
      ModalContainerNotLMC.container.id = 'ModalNotLMC';
      ModalContainerNotLMC.container.hidden = true;
      document.body.appendChild(ModalContainerNotLMC.container);
      m.mount(ModalContainerNotLMC.container, m.component(ModalNotLMC, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (title, message, buttons= null, idElement = null) {
    ModalContainerNotLMC.container = document.querySelector('#ModalNotLMC');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerNotLMC.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerNotLMC.removeAll = removeAll;
    if (ModalContainerNotLMC.container) {
      // if(title){
      // document.getElementById("modalTitleLmc").innerHTML = title;
      // }
      // if(message){
      // document.getElementById("modalContentLmc").innerHTML = message;
      // }
      /*if(buttons){
          document.getElementById("modalButtons").innerHTML = "";
          document.getElementById("modalButtons").append(buttons);
      }*/


      ModalContainerNotLMC.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerNotLMC.container.hidden = true;
  }
};
